// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GoalQuestionForm from './GoalQuestionForm';
// css
import '../../styles/components/goals/KeyGoalList.scss';


/**
 * Wraps the Table and Carousel for browsing questions in a specific area
 */
class KeyGoalsList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { questions } = this.props;

    return (
      <div className='key-goals-list'>
        <div className='list-mode'>
          {questions && questions
            .sort((a, b) => a.order - b.order)
            .map(q =>
              (<GoalQuestionForm
                question={q}
                key={q.id}
            />)
          )}
        </div>
      </div>
    );
  }
}

KeyGoalsList.propTypes = {
  questions: PropTypes.array
};

export default KeyGoalsList;



// WEBPACK FOOTER //
// ./src/components/goals/KeyGoalsList.js